import _ from 'lodash';
import { Component, Input, EventEmitter, Output } from '@angular/core';
import { ForwarderService, Region, Speciality, CorpInfo } from '../../../services/index'
declare var $:any;

@Component({
  selector: 'corp-cnsltn-setting',
  templateUrl: 'corp-cnsltn-setting.html'
})
export class CorpCnsltnSettingComponent {

  @Output() hideEe: EventEmitter<any> = new EventEmitter();
  @Input() specialityItemList:Array<Speciality> = new Array();

  _corpId:number;
  @Input() set corpId(corpId){
    if(!corpId) return;
    this._corpId = corpId;
    this.getCorpInfo();
  }

  get corpId(){
    return this._corpId;
  }

  corpInfo:CorpInfo = new CorpInfo();  

  getThisItemIsCheckd(itemId) {
    if(_.findIndex(this.corpInfo.specialityList, {itemId: itemId}) >= 0) {
      return 'checked';
    } else {
      return null;
    }
  }

  constructor(
    private forwarderService:ForwarderService
  ) {
    
  }

  ngOnInit() {
        
  }

  onChangeSpc(specialityItem, checked) {
    if (checked) {
      this.corpInfo.specialityList.push(specialityItem);
    } else {
      let index = _.findIndex(this.corpInfo.specialityList, {itemId: specialityItem.itemId});
      if (specialityItem.itemId == 23) this.corpInfo.specialityList[index].remark = null;
      this.corpInfo.specialityList.splice(index, 1);
    }
  }

  getCorpInfo(){
    this.forwarderService.getCorpInfoForCnsltnSetting(this.corpId).subscribe( resp => {
      if(resp.result){
        this.corpInfo = resp.data;
      }
    });
  }
  
  postCorpInfoForCnsltnSetting(){
    
    if(this.corpInfo.specialityList){
      this.corpInfo.specialityList = _.map(this.corpInfo.specialityList, (s:Speciality) =>{
        s.purposeCd = 1;
        return s;
      });
    }

    if(this.corpInfo.regionList){
      this.corpInfo.regionList = _.map(this.corpInfo.regionList, (r:Region) =>{
        r.purposeCd = 1;
        return r;
      });
    }

    this.forwarderService.postCorpInfoForCnsltnSetting(this.corpId, this.corpInfo).subscribe( resp => {
      if(resp.result) {
        $.sweetModal({
          content: '저장되었습니다.',
          icon: $.sweetModal.ICON_SUCCESS,
        });
        this.close();
      }else {
        $.sweetModal({
          content: resp.errorMsg,
          icon: $.sweetModal.ICON_WARNING
        })
      }
    });
  }

  close(){
    this.hideEe.emit();
  }
}


// WEBPACK FOOTER //
// ./src/app/containers/fwdr/detail/corp-cnsltn-setting.ts